import { Box, Flex, Heading, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { HelpTicketsTable } from "../../components/help-tickets-table/help-tickets-table.comp";

export function Inbox() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>Inbox</Heading>
            </Flex>
            <Tabs variant="enclosed" colorScheme="teal">
                <TabList>
                    <Tab>Inbox</Tab>
                    <Tab>Resolved</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        <HelpTicketsTable searchOptions={{ resolved: false }} />
                    </TabPanel>
                    <TabPanel>
                        <HelpTicketsTable searchOptions={{ resolved: true }} />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}
